import PageArticleList from "@src/app/components/ArticleList/PageArticleList";
import { SocialShareLinks } from "@src/app/components/SocialShare/SocialShare";
import VideoPlayerWithWidgets from "@src/app/components/VideoPlayerWithWidgets/VideoPlayerWithWidgets";
import { useRouteResponse } from "@src/app/hooks/useRouteResponse";
import { useTheme } from "@src/app/hooks/useTheme";
import { createMetaTags } from "@src/app/utils/createMetaTags";
import { isThisUrlFrom } from "@src/app/utils/tools";
import type { LinksFunction, LoaderFunction } from "react-router";

import { fetchKeywordPageData } from "./Keywords.server";

export const loader: LoaderFunction = (args) =>
  fetchKeywordPageData({ ...args, params: { tag: "video" } });

export const meta = () => {
  const tagName = "Video";
  return createMetaTags({
    title: `${tagName} | Big Reads, Opinions & Columns on China | ThinkChina`,
    description: `${tagName} - Get latest insights on ${tagName} through the eyes of global thought leaders & journalists.`,
    canonical: `https://www.thinkchina.sg/tags/video`,
    ogInfo: {
      ogTitle: `${tagName} | Big Reads, Opinions & Columns on China`,
    },
  });
};

export const links: LinksFunction = () => {
  return [...SocialShareLinks()];
};

export default function VideoCategoryPage() {
  const res = useRouteResponse("videoPage");

  console.log(res, "VideoCategory");

  const videoPlaylist = (res.videoPlaylist || []).filter(
    (item) =>
      item.youtubeUrl &&
      item.youtubeUrl.length > 0 &&
      isThisUrlFrom(item.youtubeUrl, "youtube.com"),
  );

  const theme = useTheme();

  return (
    <div>
      {/* Video Playlist */}
      {videoPlaylist.length > 0 && (
        <div className="mx-auto max-w-300">
          <VideoPlayerWithWidgets articles={videoPlaylist} />
        </div>
      )}

      {/* Articles */}
      <PageArticleList
        initialData={res.articles || []}
        theme={theme}
        title="Latest Videos"
        requestPath={`/tags/${res.tagId || ""}`}
        showSubHeader={false}
        pageSize={6}
      />
    </div>
  );
}
